import { getFunctions, httpsCallable } from 'firebase/functions';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { app, db } from './firebaseConfig';
import { HouseholdInvitation } from '../domain';

const functions = getFunctions(app, 'europe-west1');

export class InvitationService {
  private sendFn = httpsCallable<{ householdId: string; invitedEmail: string; asChild: boolean }, { invitationId: string }>(
    functions,
    'invitation-sendHouseholdInvitation',
  );

  private acceptFn = httpsCallable<{ invitationId: string }, { success: boolean }>(
    functions,
    'invitation-acceptHouseholdInvitation',
  );

  private rejectFn = httpsCallable<{ invitationId: string }, { success: boolean }>(
    functions,
    'invitation-rejectHouseholdInvitation',
  );

  async sendInvitation(householdId: string, invitedEmail: string, asChild = false): Promise<void> {
    await this.sendFn({ householdId, invitedEmail, asChild });
  }

  async acceptInvitation(invitationId: string): Promise<void> {
    await this.acceptFn({ invitationId });
  }

  async rejectInvitation(invitationId: string): Promise<void> {
    await this.rejectFn({ invitationId });
  }

  async getPendingInvitations(userEmail: string): Promise<HouseholdInvitation[]> {
    const q = query(
      collection(db, 'invitations'),
      where('invited_email', '==', userEmail.toLowerCase()),
      where('status', '==', 'pending'),
    );

    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        household_id: data.household_id,
        household_name: data.household_name,
        invited_by_uid: data.invited_by_uid,
        invited_by_name: data.invited_by_name,
        invited_email: data.invited_email,
        invited_uid: data.invited_uid,
        as_child: data.as_child === true,
        status: data.status,
        created_at: data.created_at,
        updated_at: data.updated_at,
      } as HouseholdInvitation;
    });
  }
}

export const invitationService = new InvitationService();
